import Report from "@/api/Report";
import Production from "@/api/Production";
import Submissions from "@/api/Submissions";
import WorkInProgress from "@/api/WorkInProgress";
import OrderSubmission from "@/api/OrderSubmission";
import ReferralList from "@/api/ReferralList";
import QuotationList from "@/api/QuotationList";
import UnderwritingTools from "@/api/UnderwritingTools";
import CoverholderProducts from "@/api/CoverholderProducts";
import UnderwritingToolsOther from "@/api/UnderwritingToolsOther";
import DocumentCategory from "@/api/DocumentCategory";
import DocumentType from "@/api/DocumentType";
import CoverholderDocumentType from "@/api/CoverholderDocumentType";
import EmailAddress from "@/api/EmailAddress";
import SalesDocument from "@/api/SalesDocument";
import PolicyCertificate from "@/api/PolicyCertificate";
import DashboardPolicyProduction from "@/api/DashboardPolicyProduction";
import ChartInfo from "@/api/ChartInfo";
import UserInformation from "@/api/UserInformation";
import UserRoles from "@/api/UserRoles";
import SubmitRater from "@/api/SubmitRater";
import SubmitReferral from "@/api/SubmitReferral";
import SubmitQuotation  from "@/api/SubmitQuotation";
import GridOptions from "@/api/GridOptions";
import ClaimNotifications from "@/api/ClaimNotifications";
import Impersonate from "@/api/Impersonate";
import News from "@/api/News";

class Manager {
  constructor() {
    this.reports = Report;
    this.productions = Production;
    this.submissions = Submissions;
    this.workInProgress = WorkInProgress;
    this.orderSubmission = OrderSubmission;
    this.referralList = ReferralList;
    this.quotationList = QuotationList;
    this.underwritingTools = UnderwritingTools;
    this.coverholderProducts = CoverholderProducts;
    this.underwritingToolsOther = UnderwritingToolsOther;
    this.documentCategories = DocumentCategory;
    this.documentTypes = DocumentType;
    this.coverholderDocumentTypes = CoverholderDocumentType;
    this.claimNotifications = ClaimNotifications;
    this.emailAddresses = EmailAddress;
    this.salesDocument = SalesDocument;
    this.policyCertificate = PolicyCertificate;
    this.dashboardPolicyProduction = DashboardPolicyProduction;
    this.userInformation = UserInformation;
    this.userRoles = UserRoles;
    this.chartInfo = ChartInfo;
    this.gridOptions = GridOptions;
    this.impersonate = Impersonate;
    this.submitRater = SubmitRater;
    this.submitReferral = SubmitReferral;
    this.submitQuotation = SubmitQuotation;
    this.news = News;
  }
}

export default Manager;
